import { Box, styled } from '@mui/material';
var StyledModalFooterContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    marginTop: theme.spacing(4)
  };
  return styles;
});
export { StyledModalFooterContainer };